import {TotalPrice} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/total_price.types';
import {BasketTitle} from '@aboutyou/ui-components';
import React from 'react';

export interface BasketPageTitleProps {
  showPrice?: boolean;
}

export const BasketPageTitleView: React.FC<
  {
    basketItemCount: number;
    totalPrice?: TotalPrice;
  } & BasketPageTitleProps
> = ({basketItemCount}) => {
  const isBasketEmpty = basketItemCount === 0;

  if (isBasketEmpty) {
    return null;
  }

  return <BasketTitle data-testid="basketTitleAndItems" />;
};
